import CircularProgress, {CircularProgressProps} from '@mui/material/CircularProgress';
import LinearProgress, {LinearProgressProps} from '@mui/material/LinearProgress';

import {styled} from '@mui/material/styles';

export const CCircularProgress = styled(CircularProgress)<CircularProgressProps>(
  (/* { theme } */) => ({
  }),
);

export const CLinearProgress = styled(LinearProgress)<LinearProgressProps>(
  (/* { theme } */) => ({
  }),
);
